<template>
  <el-dialog
    :visible="!!editingProject"
    title="修改设置"
    width="1000px"
    @close="closeDialog"
  >
    <el-form :model="detail" ref="form" :rules="rules" label-width="150px">
      <el-form-item label="币种：" prop="coinType">
        <span>{{ detail.coinType }}</span>
      </el-form-item>
      <el-form-item label="单次最小存入金额：" prop="minAmount">
        <el-input-number
          v-model="detail.minAmount"
          :min="0.0001"
        ></el-input-number>
      </el-form-item>
      <el-form-item label="精度：" prop="scale">
        <el-input-number v-model="detail.scale" :min="0"></el-input-number>
      </el-form-item>
      <el-form-item label="定期时长：" prop="day">
        <el-input-number v-model="detail.day" :min="1"></el-input-number>
      </el-form-item>
      <el-form-item label="利率：" prop="annualrate">
        <el-input-number
          v-model="detail.annualrate"
          :min="0"
          :max="1"
          :step="0.01"
        ></el-input-number>
      </el-form-item>
      <el-form-item label="利率规则：" prop="rateText">
        <el-input type="textarea" v-model="detail.rateText"></el-input>
      </el-form-item>
      <el-form-item label="违约费率：" prop="defaultRate">
        <el-input-number
          v-model="detail.defaultRate"
          :min="0"
          :max="1"
          :step="0.01"
        ></el-input-number>
      </el-form-item>
      <el-form-item label="违约规则：" prop="defaultRateText">
        <el-input type="textarea" v-model="detail.defaultRateText"></el-input>
      </el-form-item>
      <el-form-item label="收益说明：" prop="interestText">
        <el-input type="textarea" v-model="detail.interestText"></el-input>
      </el-form-item>
      <el-form-item label="利率说明图片：" prop="rateImg">
        <upload v-model="detail.rateImg"></upload>
      </el-form-item>
      <el-form-item label="是否允许存入：" prop="status">
        <el-switch v-model="detail.status"></el-switch>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取消</el-button>
      <el-button type="primary" @click="handleSave()">保存</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';
import Upload from 'components/upload';
export default {
  name: 'pledgeCornucopia',
  data() {
    return {
      detail: {
        status: true
      },
      rules: {
        coinType: {
          required: true,
          message: '请填写'
        },
        minAmount: {
          required: true,
          message: '请填写'
        },
        scale: {
          required: true,
          message: '请填写'
        },
        day: {
          required: true,
          message: '请填写'
        },
        annualrate: {
          required: true,
          message: '请填写'
        },
        defaultRate: {
          required: true,
          message: '请填写'
        }
      }
    };
  },
  computed: {
    ...mapState('pledgeCornucopia', ['coinTypeList', 'editingProject']),
    disalbed() {
      return this.detail && this.detail.status !== 0;
    }
  },
  watch: {
    editingProject(val) {
      if (val) {
        this.detail = {
          ...val,
          status: val.status == 1 ? true : false
        };
      } else {
        this.detail = {};
      }
    }
  },
  components: {
    Upload
  },
  methods: {
    ...mapMutations('pledgeCornucopia', ['setEditingProject']),
    ...mapActions('pledgeCornucopia', ['update']),
    closeDialog() {
      this.setEditingProject(null);
      this.$refs['form'].resetFields();
    },
    handleSave() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.doSave();
        }
      });
    },
    doSave() {
      if (this.detail.status) {
        this.detail.status = 1;
      } else {
        this.detail.status = 0;
      }
      const submitData = {
        ...this.detail,
        status: this.detail.status
      };

      this.update(submitData).then(() => {
        this.$message({
          message: '修改成功！',
          type: 'success'
        });
        this.closeDialog();
        this.$emit('refresh');
      });
    }
  }
};
</script>
